<template>
  <Transition name="modal-fade">
    <div v-if="value" class="custom-modal-overlay" @click.self="close">
      <div class="custom-modal-dialog">
        <!-- Header -->
        <div class="custom-modal-header">
          <div class="header-info">
            <div class="header-icon-box">
              <i class="la la-route"></i>
            </div>
            <div>
              <h3 class="header-title">Tracking Permohonan</h3>
              <p class="header-subtitle">Lacak status dan riwayat pengajuan permohonan Anda</p>
            </div>
          </div>
          <button type="button" class="btn-close-icon" @click="close">
            <i class="la la-times"></i>
          </button>
        </div>

        <!-- Body -->
        <div class="custom-modal-body">
          <!-- Empty State -->
          <div v-if="!progressPermohonan || progressPermohonan.length === 0" class="tracking-empty">
            <div class="empty-icon">
              <i class="la la-folder-open"></i>
            </div>
            <h4>Tidak Ada Data Tracking</h4>
            <p>Belum ada riwayat proses untuk permohonan ini.</p>
          </div>

          <!-- Timeline -->
          <div v-else class="tracking-timeline">
            <div 
              v-for="(data, index) in progressPermohonan" 
              :key="index"
              class="timeline-row"
              :class="{ 'is-latest': index === 0 }"
            >
              <!-- Indicator Icon / Line -->
              <div class="timeline-indicator">
                <div class="badge-icon" :class="getBadgeClass(data, index)">
                  <i :class="getIconClass(data, index)"></i>
                </div>
                <div v-if="index !== progressPermohonan.length - 1" class="connecting-line"></div>
              </div>

              <!-- Card Event -->
              <div class="timeline-card">
                <div class="card-head">
                  <div class="card-title-group">
                    <span v-if="index === 0" class="status-tag">Status Terkini</span>
                    <h5 class="status-name">{{ data.status_permohonan || 'Proses Permohonan' }}</h5>
                  </div>
                  <div class="time-stamp">
                    <i class="la la-clock"></i>
                    <span>{{ format_date(data.createdAt, 'HH:mm - DD MMMM YYYY') }}</span>
                  </div>
                </div>

                <!-- Instansi -->
                <div v-if="data.instansi_pemohon" class="agency-info">
                  <i class="la la-building"></i>
                  <span>{{ data.instansi_pemohon }}</span>
                </div>

                <!-- Catatan / Keterangan -->
                <div v-if="data.catatan" class="note-box">
                  <i class="la la-exclamation-circle note-icon"></i>
                  <div class="note-content" v-html="data.catatan"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="custom-modal-footer">
          <button type="button" class="btn-custom-close" @click="close">
            <i class="la la-times"></i> Tutup
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { formatDate } from '../../../helper/helpernew';

export default {
  name: 'ModalTrackingCustom',
  props: {
    // Properti 'value' untuk v-model kontrol buka/tutup modal
    value: {
      type: Boolean,
      default: false
    },
    progressPermohonan: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    format_date(val, format) {
      if (val) return formatDate(val, format);
    },
    close() {
      this.$emit('input', false);
    },
    getBadgeClass(data, index) {
      if (index === 0) return 'badge-primary';
      if (data.catatan) return 'badge-warning';
      return 'badge-default';
    },
    getIconClass(data, index) {
      if (index === 0) return 'la la-check-circle';
      if (data.catatan) return 'la la-exclamation-triangle';
      return 'la la-dot-circle';
    }
  }
}
</script>

<style scoped>
/* ==========================================
   OVERLAY & CONTAINER (PURE CUSTOM)
   ========================================== */
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.custom-modal-dialog {
  background: #ffffff;
  width: 100%;
  max-width: 720px;
  max-height: 90vh;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: modalSlideUp 0.25s ease-out;
}

/* ==========================================
   HEADER
   ========================================== */
.custom-modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 14px;
}

.header-icon-box {
  width: 44px;
  height: 44px;
  background: #eff6ff;
  color: #2563eb;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  flex-shrink: 0;
}

.header-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}

.header-subtitle {
  margin: 2px 0 0 0;
  font-size: 13px;
  color: #64748b;
}

.btn-close-icon {
  background: transparent;
  border: none;
  font-size: 20px;
  color: #94a3b8;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-close-icon:hover {
  background: #f1f5f9;
  color: #0f172a;
}

/* ==========================================
   BODY & TIMELINE
   ========================================== */
.custom-modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

/* Empty State */
.tracking-empty {
  text-align: center;
  padding: 40px 20px;
}

.empty-icon {
  font-size: 56px;
  color: #cbd5e1;
  margin-bottom: 12px;
}

.tracking-empty h4 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #334155;
}

.tracking-empty p {
  margin: 0;
  font-size: 13px;
  color: #94a3b8;
}

/* Timeline Layout */
.tracking-timeline {
  display: flex;
  flex-direction: column;
}

.timeline-row {
  display: flex;
  gap: 16px;
}

.timeline-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.badge-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
  z-index: 2;
}

.badge-primary {
  background: #2563eb;
  color: #ffffff;
  box-shadow: 0 0 0 4px #dbeafe;
}

.badge-warning {
  background: #f59e0b;
  color: #ffffff;
  box-shadow: 0 0 0 4px #fef3c7;
}

.badge-default {
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #cbd5e1;
}

.connecting-line {
  width: 2px;
  background: #e2e8f0;
  flex: 1;
  margin: 6px 0;
}

/* Timeline Card */
.timeline-card {
  flex: 1;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  transition: all 0.2s;
}

.timeline-row.is-latest .timeline-card {
  background: #ffffff;
  border-left: 4px solid #2563eb;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.card-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 8px;
}

.status-tag {
  display: inline-block;
  background: #eff6ff;
  color: #2563eb;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 6px;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.status-name {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}

.time-stamp {
  font-size: 12px;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.agency-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #475569;
  margin-bottom: 8px;
}

.note-box {
  margin-top: 10px;
  padding: 10px 12px;
  background: #fef2f2;
  border-left: 3px solid #ef4444;
  border-radius: 6px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.note-icon {
  color: #ef4444;
  font-size: 16px;
  margin-top: 2px;
  flex-shrink: 0;
}

.note-content {
  font-size: 13px;
  color: #991b1b;
}

/* ==========================================
   FOOTER
   ========================================== */
.custom-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: flex-end;
  background: #f8fafc;
}

.btn-custom-close {
  background: #64748b;
  color: #ffffff;
  border: none;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background 0.2s;
}

.btn-custom-close:hover {
  background: #475569;
}

/* ==========================================
   ANIMATIONS
   ========================================== */
@keyframes modalSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
</style>